<template>
    <img src="~@assets/img/small_loader.gif" alt=""/>
</template>

<script>
export default {
    name: 'AppLoaderGif'
};
</script>
